import { Inject, Injectable } from '@angular/core';
import { WINDOW_INJECTION_TOKEN } from 'src/app/injection-tokens';
import { CvConfigurationServiceBase } from 'src/shared/services/cv-configuration-service-base';
import { SharedServiceHelperService } from './shared-service-helper.service';

@Injectable({
    providedIn: 'root'
})
export class CvConfigurationService extends CvConfigurationServiceBase {
    constructor(
        sshs: SharedServiceHelperService,
        @Inject(WINDOW_INJECTION_TOKEN) window: Window,
    ) {
        super(sshs.getSharedServicesEnabled(), window);
    }
}
